<template>
  <div class="w-5/6 py-4">
      <div class="bg-corange rounded-md p-4">
          <h1 class="text-2xl text-cdark pb-2">Spearman's Rank Correlation Outcomes</h1>
          <p class="text-cfontgrey">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cumque ipsa adipisci modi perferendis nobis similique quidem repellendus culpa dignissimos quas.</p>
      </div>
  </div>
</template>

<script>
export default {
    name: 'AtomSpearmanInfo'
}
</script>

<style scoped>

</style>
